export const QUERY_KEYS = {
  ACCESSORIES: 'ACCESSORIES',
  BASKET: 'BASKET',
  BASKET_ORDERED: 'BASKET_ORDERED',
  DELIVERY_POINTS: 'DELIVERY_POINTS',
  DELIVERY_OPTIONS: 'DELIVERY_OPTIONS',
  DELIVERY_OPTIONS_GROUPED: 'DELIVERY_OPTIONS_GROUPED',
  PAYMENT_METHODS: 'PAYMENT_METHODS',
  PREDEFINED_WISHES: 'PREDEFINED_WISHES',
  GET_ORDER: 'GET_ORDER',
  GET_ACCOUNTING_NOTE: 'GET_ACCOUNTING_NOTE',
  GET_VOUCHER: 'GET_VOUCHER',
  MARKETING_CONSENTS: 'MARKETING_CONSENTS',
  RESTORE_BASKET: 'RESTORE_BASKET',
  ORDER: 'ORDER',
  PLACE_ORDER: 'PLACE_ORDER',
};
